import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-weight: 500;
`;

export const Input = styled.input`

`;